import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getSubNavOrg: () => NavRoute = () => {
	return {
		name: getName()
        , href: 'organizations'
		, security: security => security.manageOrgUsers
		, children: getOrganizationAreas()
        , isSubNav: true
	};
};

function getName() : string {
	let name: string;
	let url = globalThis.location.href;
	if (
		url.includes('organizations/org/details/')
		|| url.includes('organizations/org/events/')
		|| url.includes('organizations/org/logins/')
		|| url.includes('organizations/org/associated-sites/')
		|| url.includes('organizations/org/associated-users/')
		|| url.includes('organizations/org/audit-history/')
	) { name = "Edit Organization"; } 
	else { name = "Organizations"; }

	return name;
}

function getOrganizationAreas() : NavRoute[] {
	let id: string = "";
	let url = globalThis.location.href;
	if (url.includes('organizations/org/details/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('organizations/org/events/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('organizations/org/logins/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('organizations/org/associated-sites/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('organizations/org/associated-users/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('organizations/org/audit-history/')) { id = url.substring(url.lastIndexOf('/') + 1); }

	// Organizations list
	if (id === "") { 
		return [
			{
				name: 'By Event'
				, exact: true
				, path: 'organizations/list'
                , activeNavLink: 'organizations/list'
		        , secondaryNav: ['Organizations', 'By Event']
			}
		]; 
	}

	// Creating a new Organization
	if (+id === 0)
	{
		return [
			{
				name: 'Back'
				, exact: true
				, path: `organizations/list`
			}
            , {
				name: 'Details'
				, exact: true
				, path: `organizations/org/details/${id}`
                , activeNavLink: 'organizations/org/details'
				, secondaryNav: ['Organizations', 'Edit', 'Details']
			}
		];
	}

	// Organization details
	return [
		{
			name: 'Back'
			, exact: true
			, path: 'organizations/list'
		}
		, {
			name: 'Details'
			, exact: true
			, path: `organizations/org/details/${id}`
            , activeNavLink: 'organizations/org/details'
            , secondaryNav: ['Organizations', 'Edit', 'Details']
		}
		, {
			name: 'Login Types'
			, exact: true
			, path: `organizations/org/logins/${id}`
			, security: security => security.adminFeatures
            , activeNavLink: 'organizations/org/logins'
            , secondaryNav: ['Organizations', 'Edit', 'Login Types']
		}
		, {
			name: 'Associated Events'
			, exact: true
			, path: `organizations/org/events/${id}`
			, security: security => security.adminFeatures
            , activeNavLink: 'organizations/org/events'
            , secondaryNav: ['Organizations', 'Edit', 'Associated Events']
		}
		, {
			name: 'Associated Sites'
			, exact: true
			, path: `organizations/org/associated-sites/${id}`
            , activeNavLink: 'organizations/org/associated-sites'
            , secondaryNav: ['Organizations', 'Edit', 'Associated Sites']
		}
		, {
			name: 'Associated Users'
			, exact: true
			, path: `organizations/org/associated-users/${id}`
            , activeNavLink: 'organizations/org/associated-users'
            , secondaryNav: ['Organizations', 'Edit', 'Associated Users']
		}
		, {
			name: 'Audit History'
			, exact: true
			, path: `organizations/org/audit-history/${id}`
            , activeNavLink: 'organizations/org/audit-history'
            , secondaryNav: ['Organizations', 'Edit', 'Audit History']
		}
	];
}